/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 59a99c5e (Wed Sep  2 22:08:21 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Request body for updating transcript on-hold status
 * @export
 * @interface UpdateTranscriptOnHoldStatusRequestBody
 */
export interface UpdateTranscriptOnHoldStatusRequestBody {
  /**
   * Transcript key to update
   * @type number
   * @memberof UpdateTranscriptOnHoldStatusRequestBody
   */
  transcriptKey: number
  /**
   * Boolean indicating whether to put transcript on hold or remove from hold
   * @type boolean
   * @memberof UpdateTranscriptOnHoldStatusRequestBody
   */
  isOnHold: boolean
}

export function UpdateTranscriptOnHoldStatusRequestBodyFromJSON(
  json: any
): UpdateTranscriptOnHoldStatusRequestBody {
  return UpdateTranscriptOnHoldStatusRequestBodyFromJSONTyped(json, false)
}

export function UpdateTranscriptOnHoldStatusRequestBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UpdateTranscriptOnHoldStatusRequestBody {
  if (json === undefined || json === null) {
    return json
  }
  return {
    transcriptKey: json['transcriptKey'],
    isOnHold: json['isOnHold'],
  }
}

export function UpdateTranscriptOnHoldStatusRequestBodyToJSON(
  value?: UpdateTranscriptOnHoldStatusRequestBody | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    transcriptKey: value.transcriptKey,
    isOnHold: value.isOnHold,
  }
}
